// extracted by mini-css-extract-plugin
module.exports = {"breakpointS":"0","breakpointM":"860px","breakpointL":"1024px"};